import { RobotMowerIcon } from './RobotMowerIcon';

/**
 * author: Kristian Mohl
 * id 2029DE02-EC25-4242-945F-D7495F35D071
 * name robot-mower
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/robot-mower.svg
 * tags
 * - Home Automation 
 * - Hardware / Tools 
 */
export const LawnMowerIcon = RobotMowerIcon;
export default LawnMowerIcon